import * as React from 'react';

export const TipTapEditableContext = React.createContext(true);
